import React from 'react';
import { LinkType } from '../types';
import { useTranslation } from 'react-i18next';

interface IProps {
  type: LinkType;
  url: string;
  children?: React.ReactNode;
  title?: string;
  srText?: string;
}

const Link = ({ type, url, children, title, srText }: IProps) => {
  const { t } = useTranslation();
  
  const commonProps = {
    href: url,
    title,
    className: 'link-wrapper',
  };
  
  const labelText =
    type === LinkType.Extern
      ? `${srText || title} (${t('global.opensInNewTab')})`
      : srText || title;

  switch (type) {
    case LinkType.Download:
      return (
        <a
          {...commonProps}
          download
          target="_self"
          aria-label={labelText}
        >
          {children}
        </a>
      );

    case LinkType.Extern:
      return (
        <a
          {...commonProps}
          rel="noopener noreferrer"
          target="_blank"
          aria-label={labelText}
        >
          {children}
        </a>
      );

    default:
      return (
        <a {...commonProps} aria-label={labelText}>
          {children}
        </a>
      );
  }
};

export default Link;